<template lang="pug">
#selecionar-car
    .bloco-pesquisa-filtros__barra-pesquisa
        i.el-icon-search
        input(
            :placeholder='$t("laudos.digiteONumeroDoCar ")',
            prefix-icon='el-icon-search',
            v-mask='`XX-XXXXXXX-XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX`',
            v-model='carSelecionado',
            type='text',
            @input='handlerCarSelecionado',
            @keyup.enter='buscarCar'
        )
    .conteudo
        div(v-if='carExibicao')
            h3.mb-3 {{ $t('laudos.informacoesDoCar') }}
            p.mb-1 {{ $t('laudos.areaHa') }}: {{ carExibicao.areaHa }}
            p.mb-1 {{ $t('mensagens.comuns.municipioUf') }}: {{ carExibicao.municipioUF }}
            p.mb-1 {{ $t('laudos.situacao') }}: {{ carExibicao.situacao }}
    el-divider.custom-divider
    .botao.marginButton(slot='footer')
        BaseButton.cancel-button(type='outline', @click='cancelarModal') {{ $t('mensagens.comuns.cancelar') }}
        BaseButton#idAdicionar.confirm-button(
            type='primary',
            @click='enviarCarSelecionado',
            :disabled='!existeCarNaBaseLyra || !isValid'
        )
            | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import UtilsService from '@/modules/laudos/services/UtilsService';
import formatters from '@/modules/laudos/utils/formatters';
import LaudosService from '@/modules/laudos/services/LaudosService';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import StatusCar from '@/constants/StatusCar';
import BaseButton from '@/modules/laudos/components/BaseButton.vue';
import CarUtils from '@/modules/laudos/utils/CarUtils';

export default {
    name: 'SelecionarCar',
    components: {
        BaseButton
    },
    props: {
        tipoLaudo: {
            type: Number,
            required: true
        },
        produtorBiomassa: {
            type: Object,
            default: null
        },
        pessoas: {
            type: Array,
            default: () => []
        }
    },
    emits: ['cancelar-modal', 'getLaudos', 'carJaCadastradosEncontrados'],
    data() {
        return {
            carSelecionado: '',
            carExibicao: null,
            car: {},
            existeCarNaBaseLyra: false,
            informacaoLaudosTipo: []
        };
    },
    computed: {
        isValid() {
            return !this.produtorBiomassa || this.produtorBiomassa.valido;
        }
    },
    methods: {
        async obterDadosCarSemGeo() {
            try {
                const car = this.carSelecionado;
                const { data } = await UtilsService.getDadosCARSemGeometria(
                    car
                );
                this.carExibicao = {
                    areaHa: formatters.formatNumber(data.areaHa, 2),
                    municipioUF: `${data.nomeMunicipio}/${data.uf}`,
                    situacao: StatusCar[data.situacao]
                };
                this.car = {
                    codigo: data.codigo,
                    condicao: data.situacao
                };
                this.existeCarNaBaseLyra = true;
            } catch (error) {
                this.existeCarNaBaseLyra = false;
                throw error;
            }
        },
        async obterDadosCar() {
            try {
                const codigosCar = this.carSelecionado;
                const { data } = await UtilsService.getDadosCAR({ codigosCar });

                this.car = {
                    codigo: data.resultados[0].properties.codigo,
                    condicao: data.resultados[0].properties.situacao
                };
                this.existeCarNaBaseLyra = data.resultados.length > 0;
            } catch (error) {
                this.existeCarNaBaseLyra = false;
                throw error;
            }
        },
        handlerCarSelecionado(event) {
            const value = event.target.value;
            const formatoCarValido = value && CarUtils.isCar(value);

            if (formatoCarValido) {
                this.buscarCar();
            }
        },
        async buscarCar() {
            const informacaoInvalida =
                'mensagens.diagnosticoSocioambiental.erro.informacaoInvalida';
            const formatoCarValido = CarUtils.isCar(this.carSelecionado);

            if (this.carSelecionado === this.car.codigo) {
                return;
            }

            if (!formatoCarValido) {
                return this.$notify.warning(this.$t(informacaoInvalida));
            }
            try {
                await this.obterDadosCarSemGeo();
                await this.obterDadosCar();
            } catch {
                this.carExibicao = null;
                this.$notify.error({
                    message: this.$t('laudos.erro.ocorreuUmErroAoBuscarCar')
                });
            }
            if (!this.existeCarNaBaseLyra) {
                this.carExibicao = null;
                this.$notify.warning({
                    message: this.$t('laudos.erro.carNaoEncontradoNaBaseDoLyra')
                });
            }
        },
        enviarCarSelecionado() {
            if (this.tipoLaudo === TipoLaudo.RENOVABIO) {
                this.verificarCarRenovabio();
            } else {
                this.cadastrarLaudos();
            }
        },
        verificarCarRenovabio() {
            let verificarLaudos = [
                {
                    car: this.car.codigo,
                    cpfCnpjProdutorBiomassa:
                        formatters.removerPontuacaoDocumento(
                            this.produtorBiomassa.cpfCnpj
                        ),
                    nomeRazaoSocialProdutorBiomassa:
                        this.produtorBiomassa.nomeRazaoSocial
                }
            ];

            LaudosService.verificarLaudosNovos(
                verificarLaudos,
                TipoLaudo.RENOVABIO
            )
                .then(response => {
                    const dados = response.data;
                    let informacaoLaudos = [
                        {
                            tipoLaudoId: TipoLaudo.RENOVABIO,
                            car: {
                                codigo: this.car.codigo
                            },
                            cpfCnpjProdutorBiomassa:
                                formatters.removerPontuacaoDocumento(
                                    this.produtorBiomassa.cpfCnpj
                                ),
                            nomeRazaoSocialProdutorBiomassa:
                                this.produtorBiomassa.nomeRazaoSocial
                        }
                    ];

                    if (dados.quantidadeDuplicados > 0) {
                        this.$emit(
                            'carJaCadastradosEncontrados',
                            dados.quantidadeDuplicados,
                            informacaoLaudos,
                            dados.cars
                        );
                        this.cancelarModal();
                    } else {
                        this.cadastrarLaudos(informacaoLaudos);
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.message
                    });
                });
        },
        cadastrarLaudos(informacaoLaudos = null) {
            if (!informacaoLaudos) {
                informacaoLaudos = [
                    {
                        tipoLaudoId: this.tipoLaudo,
                        car: this.car
                    }
                ];

                if (
                    this.tipoLaudo === TipoLaudo.CONFORMIDADE &&
                    this.pessoas.length > 0
                ) {
                    informacaoLaudos[0].proprietarios = this.pessoas;
                }
            }

            LaudosService.cadastrarLaudos({ informacaoLaudos })
                .then(() => {
                    this.$notify.success({
                        message: this.$t(
                            'laudos.solicitacaoRealizadaComSucesso'
                        )
                    });
                    this.$emit('getLaudos');
                    this.cancelarModal();
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.message
                    });
                });
        },
        cancelarModal() {
            this.$emit('cancelar-modal');
        }
    }
};
</script>

<style lang="scss" scoped>
#selecionar-car {
    .bloco-pesquisa-filtros__barra-pesquisa {
        height: 40px;
        border-radius: 4px;
        width: 50%;
        display: flex;
        justify-content: center;
        border: 1px solid #dcdfe6;

        i.el-icon-search {
            color: var(--gray);
            font-size: 16px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }
    .conteudo {
        min-height: auto;
        max-height: 50vh;
        overflow-y: auto;
        color: #00413c;
        margin: 1.5rem 0;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        width: 100%;
    }
    .botao {
        margin-top: 10px;
        text-align: right;
        display: flex;
        justify-content: right;

        .cancel-button {
            border: 1px solid #00413c !important;
            color: #00413c !important;
            font-size: 14px;
            height: 2.5rem;
            width: auto;
        }

        .confirm-button {
            width: 10rem;
            height: 2.5rem;
            width: auto;
            font-size: 14px;
        }
    }

    .custom-divider {
        margin-bottom: 10px;
        margin-top: 0px;
    }
}
</style>
